import {Tabs} from 'antd';
import {checkPerm} from "../../auth/sessionTools";
import {TaskTable} from "../tasks/TaskTable";

export const CultivationTab = ({onApiFail, session, refresh, onRefresh, props}) => {
    const hasAllTasks = checkPerm(session, "allTask");

    const items = [
    ]

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Cultivation Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`Cultivation`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'DepartmentTasks'} items={items} />
}